export default __webpack_public_path__ + "static/media/store-8.cd0b1a5f.png";